import { AfterViewInit, Directive, ElementRef, Input, Renderer2, inject } from '@angular/core';

const LENGTH_DEFAULT = 10;

@Directive({
  selector: '[portalTextCut]',
  standalone: false,
})
export class TextCutDirective implements AfterViewInit {
  private readonly el = inject(ElementRef);
  private readonly renderer = inject(Renderer2);

  @Input('portalTextCut') length: number;

  ngAfterViewInit(): void {
    const nativeElement: HTMLElement = this.el.nativeElement;
    const text: string = nativeElement.innerText;
    const length = this.length || LENGTH_DEFAULT;

    if (text?.length > length) {
      const textCut = `${text.slice(0, length)}...`;
      nativeElement.innerText = textCut;
      this.renderer.setAttribute(nativeElement, 'data-title', text);
    }
  }
}
